import { ButtonRuleGroup } from '@wix/rules-panel-ui';
import React from 'react';
import { useVerticalPageGroup } from './use-vertical-page-group';
export const VerticalPageGroup = /*#__PURE__*/React.memo(_ref => {
  let {
    pageId
  } = _ref;
  const {
    verticalPageGroupProps
  } = useVerticalPageGroup({
    pageId
  });
  return /*#__PURE__*/React.createElement(ButtonRuleGroup, verticalPageGroupProps);
});
//# sourceMappingURL=vertical-page-group.js.map